import { QUERY_GET_MODELS,QUEY_GET_MASTER_COUNT,QUERY_GET_MASTER_MODELS, QUERY_GET_MODELSSPAG, QUERY_POST_CREATE_MODEL, QUERY_PUT_UPDATE_MODEL, QUERY_DELETE_DELETE_MODEL} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getMasterModels = baseThunk("Models/getMasterModels", QUERY_GET_MASTER_MODELS, "GET");

export const getModels = baseThunk(`models/getModels`, QUERY_GET_MODELS, "GET");
export const getModelsPag = baseThunk(`models/getModelsPag`, QUERY_GET_MODELSSPAG, "GET");
export const getModelsPagCount = baseThunk("models/getModelListCount", QUEY_GET_MASTER_COUNT, "GET");
export const createModel = baseThunk("models/create", QUERY_POST_CREATE_MODEL, "POST");
export const updateModel = baseThunk('models/update', QUERY_PUT_UPDATE_MODEL, "PUT")
export const deleteModel = baseThunk(`models/delete`, QUERY_DELETE_DELETE_MODEL, "DELETE")